import type { ProcessView } from "../types";

const ADOPTION: Record<ProcessView["adoption"], { glyph: string; word: string }> = {
  unknown: { glyph: "?", word: "Not known" },
  patchy: { glyph: "◔", word: "Patchy" },
  "mostly used": { glyph: "◑", word: "Mostly used" },
  embedded: { glyph: "●", word: "Embedded" },
};

/** Processes as the player perceives them (19 §4.14, 20 §8). No quality, burden or debt figures. */
export function ProcessesPanel({ processes }: { processes: ProcessView[] }) {
  const live = processes.filter((p) => p.status === "live");
  const inDesign = processes.filter((p) => p.status !== "live");
  return (
    <section className="panel" aria-labelledby="proc-title">
      <h2 id="proc-title" className="panel-title">Processes</h2>
      {processes.length === 0 && <p className="panel-note">You haven't asked anyone to design a better way of handling something yet.</p>}
      {live.length > 0 && (
        <table className="proc-table">
          <caption className="visually-hidden">Live processes</caption>
          <thead><tr><th scope="col">Process</th><th scope="col">Owner</th><th scope="col">Adoption (as you see it)</th></tr></thead>
          <tbody>
            {live.map((p) => {
              const a = ADOPTION[p.adoption];
              return (
                <tr key={p.id}>
                  <th scope="row">{p.name}{p.designer && <span className="proc-sub">designed by {p.designer.name}</span>}</th>
                  <td>{p.owner ? p.owner.name : <span className="muted">no owner</span>}</td>
                  <td><span aria-hidden="true" className="proc-glyph">{a.glyph}</span> {a.word}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
      {inDesign.length > 0 && (
        <div className="proc-design">
          <h3>In design</h3>
          <ul>{inDesign.map((p) => <li key={p.id}>{p.name}{p.designer ? ` (${p.designer.name})` : ""}</li>)}</ul>
        </div>
      )}
    </section>
  );
}
